import React from "react";
import "../lib/customLoader.css"; // Import CSS for animations

const FancySvgWithBoxes = () => {
  return (
    <div className="flex flex-col items-center justify-center mt-36">
      {/* SVG Illustration */}
      <div className="mb-10">
        {/* Paste SVG directly here */}
        <svg
          id="svg-global"
          xmlns="http://www.w3.org/2000/svg"
        //   fill="none"
          viewBox="0 0 94 136"
          height="136"
          width="94"
    
        >
         
        </svg>
      </div>

      {/* Animated 3D Boxes */}
      <div className="boxes">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="box">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FancySvgWithBoxes;
